<template>
    <!-- display buttons for remove from cart here -->
    <button @click.prevent="removeFromCartFxn(itemId)">
        <i class="fas fa-trash"></i> Remove Item
    </button>
</template>

<script>
import { mapActions } from 'vuex'
export default {
    name: 'RemoveFromCart',
    props: {
        itemId: {
            type: String,
            required: true
        },
    },
    methods: {
        ...mapActions(['cartItemsCountAction', 'fetchCartItemsAction']),
        removeFromCartFxn(theItemId) {
            if(!theItemId) return

            // prepare the carts item obj to be removed via itemId
            let theItemObj = {
                itemId: theItemId
            }

            // required array to hold cart items
            let localStorageATCItemIds = []
            
            // confirm the user already have a add-to-cart items storage on local-storage to be removed from
            localStorageATCItemIds = JSON.parse(localStorage.getItem('ani_items_atc')) 
            if(localStorageATCItemIds && localStorageATCItemIds.length) {
                // obtain the itemObj index to be used for slicing aka deleting
                let existingCartItemIndex = localStorageATCItemIds.findIndex(cartItem => cartItem.itemId === theItemObj.itemId)
                if(existingCartItemIndex !== -1){
                    localStorageATCItemIds.splice(existingCartItemIndex, 1)
                } 
                // update the cart items on local-storage after removing the item obj via itemId
                localStorage.setItem('ani_items_atc', JSON.stringify(localStorageATCItemIds))
                let cartObj = {
                    items: localStorageATCItemIds
                }
                this.fetchCartItemsAction(cartObj).then(() => {}).catch((e) => {})
            } 

            // update cart items counter via vuex action
            this.cartItemsCountAction().then(() => {}).catch((e) => {})
        },
    },
}
</script>
